"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dbFactory;

var _lokijs = require("lokijs");

var _lokijs2 = _interopRequireDefault(_lokijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var db = new _lokijs2.default("signlabs", { env: "BROWSER" });
var collections = [{
  name: "products",
  props: {
    indices: ['id']
  }
}, {
  name: "materials",
  props: {
    indices: ['id']
  }
}, {
  name: "colors",
  props: {
    indices: ['id']
  }
}, {
  name: "shapes",
  props: {
    indices: ['id']
  }
}, {
  name: "fonts",
  props: {
    indices: ['id']
  }
}, {
  name: "fix_methods",
  props: {
    indices: ['id']
  }
}];
collections.forEach(function (collection) {
  return db.addCollection(collection.name, collection.props);
});
window.db = db;
function dbFactory() {
  return db;
}

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/common/services/loki.factory.js
 **/